import type { Database } from '@shady-pines/db';
import type { SupabaseClient } from '@supabase/supabase-js';
import { createContext, useContext, useMemo } from 'react';

type SupabaseContext = {
  supabase: SupabaseClient<Database>;
};

export const SupabaseContext = createContext<SupabaseContext | null>(null);

export const useSupabase = () => {
  const context = useContext(SupabaseContext);
  if (!context) {
    throw new Error('useSupabase must be used within a SupabaseProvider');
  }

  const supabase = useMemo(() => context.supabase, [context.supabase]);
  return supabase;
};
